<template>
  <van-field
    v-bind="props.fieldProps"
    v-model="phone"
    class="from-input"
    :class="[{ phone: isPhone }]"
    type="text"
    :clearable="clearable"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :formatter="removeSpaces"
    :rules="
      rules
        ? [{ required, message: message || placeholder }, ...rules]
        : [{ required, message: message || placeholder }]
    "
  >
    <template #right-icon>
      <svg-icon :icon-name="leftIcon" :width="46" v-if="!!leftIcon" current-color />
      <!--      <div v-if="isPhone" class="phone-selector flex-center" @click="showSelector">-->
      <!--        {{checkedCountry?.id }}-->
      <!--      </div>-->
    </template>
  </van-field>
  <!--  <check-country v-model="isShowCountry" @checked="selectCountry" />-->
</template>

<script setup lang="ts">
import { computed, defineEmits, defineModel, ref } from 'vue';
import { useI18n } from '@star/languages';
import { removeSpaces } from '@star/utils';
import type { FieldProps, FieldRule } from 'vant';

type Props = {
  label?: string;
  placeholder?: string;
  name?: string;
  message?: string;
  maxlength?: number | string;
  required?: boolean;
  clearable?: boolean;
  isPhone?: boolean;
  fieldProps?: FieldProps;
  rules?: FieldRule[];
};

const props = withDefaults(defineProps<Props>(), {
  maxlength: 12,
  required: true,
  clearable: true,
  isPhone: true,
});

const emit = defineEmits(['checked']);

const { t } = useI18n();

const phone = defineModel();

const isShowCountry = ref<boolean>(false);
const checkedCountry = ref<Record<string, any>>();

const name = computed(() => {
  return props.name || 'receiveMobile';
});

const leftIcon = computed(() => {
  return props.isPhone ? 'cellphone' : 'account';
});

const label = computed(() => {
  return props.label ?? '手机号';
});

const placeholder = computed(() => {
  return props.placeholder ?? '请输入您的手机号码';
});

// const showSelector = () => {
//   isShowCountry.value = true;
// };
//
// const selectCountry = (data: any) => {
//   data.id = data.id.replace(/[a-zA-Z]/g, '');
//   checkedCountry.value = data;
//   emit('checked', data);
// };
</script>

<style lang="less" scoped>
.from-input {
  &.phone {
    :deep(.van-field) {
      &__right-icon {
        display: flex;
        align-items: center;
        min-width: 50px;
        height: 57px;
        text-align: left;
        flex: none;
      }

      //&__control {
      //  padding-left: 200px;
      //}
    }

    .phone-selector {
      color: #000;
      font-weight: 500;
      font-size: 42px;
      margin-bottom: -3px;
      margin-left: 30px;
      flex: 1;
      position: relative;
      padding-right: 39px;
      white-space: nowrap;

      &::after {
        border: 9px solid;
        border-color: transparent transparent #adadad #adadad;
        opacity: 0.8;
        content: '';
        margin-top: -15px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: rotate(-45deg);
      }

      .arrow {
        font-size: 36px;
        color: #adadad;
        transform: rotateX(90deg);
      }
    }
  }
}
</style>
